var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9835 3.55238L15.9419 3.59431L14.4036 2.04274L14.4454 2.0008C14.8482 1.57223 15.5193 1.55441 15.944 1.96096C15.9575 1.97396 15.9706 1.98717 15.9835 2.0008C16.4006 2.43231 16.4006 3.12066 15.9835 3.55238ZM9.97721 9.61195L7.94029 10.1361L8.43913 8.08134L13.2197 3.21693L14.7578 4.76851L9.97721 9.61195ZM17.1468 0.805458C16.07 -0.268486 14.3369 -0.268486 13.2598 0.805458L7.10769 7.05371C7.00085 7.15771 6.92208 7.2877 6.87905 7.43112L5.9853 11.1004C5.90237 11.3843 5.9826 11.691 6.19315 11.8972C6.35174 12.0603 6.56936 12.1513 6.79591 12.1488L6.98298 12.1068L10.6203 11.1841C10.7611 11.1484 10.8899 11.0763 10.9945 10.9746L17.1676 4.72634C18.2264 3.63415 18.217 1.88611 17.1468 0.805458Z",
    fill: "#C5D4EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13.3223,
    width: 16.628,
    height: 1.67738,
    rx: 0.838691,
    fill: "#C5D4EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.0050343bd562bcb5ddf35b292f4a65a2.svg";
export { ForwardRef as ReactComponent };